export default "__VITE_ASSET__6fe6fb3f__"